import { render, staticRenderFns, recyclableRender, components } from "./u-cell.vue?vue&type=template&id=1c4434ae&scoped=true&"
var renderjs
import script from "./u-cell.vue?vue&type=script&lang=js&"
export * from "./u-cell.vue?vue&type=script&lang=js&"
import style0 from "./u-cell.vue?vue&type=style&index=0&id=1c4434ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4434ae",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-cell/u-cell.vue"
export default component.exports